import { Box, Stack, SxProps } from "@mui/material";
import { ResponsiveStyleValue } from "@mui/system";
import { Component } from "react";

interface DetailsGridRowProps {
  direction?: ResponsiveStyleValue<"row" | "column" | "row-reverse" | "column-reverse">;
  spacing?: number;
  lineHeight?: string;
  fontSize?: string;
  sx?: SxProps;
  label?: string;
  children?: React.ReactNode;
}

export class DetailsGridRow extends Component<DetailsGridRowProps> {
  static defaultProps = {
    direction: "row",
    spacing: 2,
    lineHeight: "18px",
    fontSize: "16px"
  };

  render() {
    const { label, children, direction, spacing, lineHeight, fontSize } = this.props;

    return (
      <Stack direction={direction} spacing={spacing} sx={{ fontSize }}>
        <Box sx={{ width: "168px" }}>{label}</Box>
        <Box sx={{ fontWeight: "600", lineHeight }}>{children}</Box>
      </Stack>
    );
  }
}
